import { PillProps } from '@clearcover/atlas';

export const POLICY_STATUS_COLOR_MAP: Record<string, PillProps['variant']> = {
  Pending: 'warn',
  Unknown: 'disabled',
  Active: 'success',
  'Not Written': 'disabled',
  Expired: 'danger',
  'Active - Pending Cancellation': 'warn',
  'Active - Future Effective Date': 'success',
  Cancelled: 'danger',
  'Policyholder Non-renewal': 'disabled',
  'Clearcover Non-renewal': 'disabled',
};
